<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white"> Dashboard</router-link>
            <router-link to="/admin/eduschool/class-note-setup" class="text-white"> <i
                    class="fa fa-ellipsis-v px-2"></i>Class Note Setup</router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Class Note Lesson Setup</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card">
                        <div class="card-body">
                            <modal :show.sync="modals.noteModal" modal-classes="modal-dialog-centered modal-lg">
                                <div class="card bg-secondary border-0 mb-0">
                                    <div class="card-body">
                                        <PageSpinner :onloader="onloader" />
                                        <form role="form">
                                            <div class="row">
                                                <div class="col-md-12 pb-2">
                                                    <div class="row">
                                                        <div class="col">
                                                            <img v-if="ImagePathval" :src="ImagePathval"
                                                                class="img-fluid" />
                                                            <img v-else src="/img/brand/empty.png" class="img-fluid" />
                                                        </div>
                                                        <div class="col">
                                                            <ImageUploader @emitOutImgPathval="UpdateImagePathval" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Class Note Lesson Title</label>
                                                        <vue-editor id="ClassNoteLessonTitleval"
                                                            v-model="ClassNoteLessonTitleval">
                                                        </vue-editor>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Class Note Lesson Details</label>
                                                        <vue-editor id="ClassNoteLessonDetailsval"
                                                            v-model="ClassNoteLessonDetailsval">
                                                        </vue-editor>
                                                    </div>
                                                </div>

                                                <div class="col-lg-4">
                                                    <div class="form-group">
                                                        <label>Estimated Reading Minutes</label>
                                                        <input v-model="EstimatedReadMinutesval" type="number" min="1"
                                                            class="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <template slot="footer">

                                    <base-button type="default" @click="modals.noteModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="SubmitClassNoteLesson()">Submit
                                    </base-button>
                                </template>
                            </modal>

                            <div>
                                <div class="form-inline">
                                    <div class="row" v-if="ClassNoteItems">
                                        <div class="col-lg-12">
                                            {{ ClassNoteItems.schoolSubjectName }}
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="card-text" v-html="ClassNoteItems.classNoteDescription">
                                            </div>

                                        </div>
                                        <div class="col-lg-12">
                                            <div class="card-text" v-html="ClassNoteItems.classNote">
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div class="justify-content-end form-inline">
                                    <button class="btn btn-success mr-3" v-on:click="OpenNewnoteModal()">
                                        <i class="fa fa-edit"></i> New
                                    </button>
                                    <base-input class="input-group-alternative" placeholder="Search here..."
                                        addon-left-icon="fa fa-search" v-model="searchValueval">
                                    </base-input>
                                </div>
                                <list-skeleton v-if="!ClassNoteLessonItems" :rows="3" />
                                <div v-else>
                                    <div v-for="item in ClassNoteLessonItems" :key="item.classNoteLessonId">
                                        <div class="card mt-2">
                                            <div class="card-body bg-secondary">
                                                <div class="card">
                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            <img :src="item.imagePath" class="img-fluid" alt="...">
                                                        </div>
                                                        <div class="col-lg-9">
                                                            <h5 class="card-title" v-html="item.classNoteLessonTitle">
                                                            </h5>
                                                            <BaseMarkdown :content="item.classNoteLessonDetails" />
                                                            <!-- <div class="card-text" v-html="item.classNoteLessonDetails">
                                                            </div> -->

                                                            <div class="card-footer text-center">
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="GetById(item)">
                                                                    <i class="fa fa-edit"></i> Edit
                                                                </button>
                                                                <!-- <button class="btn btn-danger btn-sm"
                                                                    v-on:click="GetById(item.classNoteLessonId)">
                                                                    <i class="fa fa-times"></i> Delete
                                                                </button> -->
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="OpenClassNoteLessonQuestion(item.classNoteLessonId)">
                                                                    <i class="fa fa-eye"></i> View Questions
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from "@/components/PageSpinner";
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins";
import Alert from "@/mixins/Alert.mixins"
import katex from 'katex';
import 'katex/dist/katex.min.css';
import ImageUploader from "@/components/ImageUploader"
// import modal from '@/components/Modal'
window.katex = katex;
export default {
    name: "EduSchool-Lesson-Note-Setup",
    mixins: [ValidateAccessToken, Alert],
    components: {
        PageSpinner,
        VueEditor,
        ImageUploader,
        // modal
    },
    data() {
        return {
            accessDetails: null,
            ClassNoteIdval: localStorage.getItem("ClassNoteId") || "",
            ClassNoteLessonIdval: 0,
            ClassNoteLessonTitleval: "",
            ClassNoteLessonDetailsval: "",
            VideoPathval: null,
            PracticalVideoPathval: null,
            EstimatedReadMinutesval: 0,
            ImagePathval: null,
            searchValueval: "All",
            ClassNoteLessonItems: null,
            ClassNoteItems: null,
            isModified: false,
            onloader: "none",
            editorOption: {
                debug: 'info',
                placeholder: 'Type in here',
                readonlly: true,
                theme: 'snow'
            },
            modals: {
                noteModal: false
            }
        };
    },
    methods: {
        OpenNewnoteModal() {
            this.isModified = false;
            this.modals.noteModal = true
        },
        resetInput() {
            this.ClassNoteLessonTitleval = "";
            this.ClassNoteLessonDetailsval = "";
            this.EstimatedReadMinutesval = 0;
            this.VideoPathval = null;
            this.PracticalVideoPathval = null;
            this.ImagePathval = null;
        },
        OpenClassNoteLessonQuestion(Id) {
            localStorage.setItem("ClassNoteLessonId", Id);
            this.$router.push("/admin/eduschool/class-note-lesson-question-setup");
        },
        GetById(item) {
            this.resetInput();
            this.ClassNoteLessonIdval = item.classNoteLessonId;
            this.ClassNoteLessonTitleval = item.classNoteLessonTitle;
            this.ClassNoteLessonDetailsval = item.classNoteLessonDetails.normalize('NFC');
            this.EstimatedReadMinutesval = item.estimatedReadMinutes;
            this.ImagePathval = item.imagePath;
            this.PracticalVideoPathval = item.practicalVideoPath;
            this.VideoPathval = item.videoPath;
            this.isModified = true;
            this.modals.noteModal = true
        },
        SubmitClassNoteLesson() {
            let ClassNoteId = this.ClassNoteIdval;
            let ClassNoteLessonId = this.ClassNoteLessonIdval;
            let ClassNoteLessonTitle = this.ClassNoteLessonTitleval;
            let ClassNoteLessonDetails = this.ClassNoteLessonDetailsval;
            let EstimatedReadMinutes = this.EstimatedReadMinutesval;
            let ImagePath = this.ImagePathval;
            let PracticalVideoPath = this.PracticalVideoPathval;
            let VideoPath = this.VideoPathval;
            if (ClassNoteId > 0) {
                let userdata = {};
                this.onloader = "flex";
                let operationVal = "";
                if (this.isModified == false) {
                    operationVal = "ClassNote/CreateClassNoteLesson";
                    userdata = {
                        ClassNoteId,
                        ClassNoteLessonTitle,
                        ClassNoteLessonDetails,
                        EstimatedReadMinutes,
                        ImagePath,
                        PracticalVideoPath,
                        VideoPath
                    }
                } else {
                    operationVal = "ClassNote/UpdateClassNoteLesson";
                    userdata = {
                        ClassNoteLessonId,
                        ClassNoteId,
                        ClassNoteLessonTitle,
                        ClassNoteLessonDetails,
                        EstimatedReadMinutes,
                        ImagePath,
                        PracticalVideoPath,
                        VideoPath
                    }
                }
              
                this.$store
                    .dispatch(operationVal, userdata)
                    .then((resp) => {
                        this.onloader = "none";
                        if (resp.responseCode == '00') {
                            this.GetClassNoteLessons();
                            this.resetInput();
                            this.modals.noteModal = false;
                            this.ShowAlertSuccess('Submitted successfully', '');
                        } else {
                            this.ShowAlertError(resp.responseMessage, '');
                        }

                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            } else {
                this.ShowAlertError('Select Subject', '');
            }

        },
        UpdateImagePathval(data) {
            this.ImagePathval = data;
        },
        UpdateVedioPathval(data) {
            this.VedioPathval = data;
        },
        UpdatePracticalVideoval(data) {
            this.PracticalVideoval = data;
        },
        GetClassNoteById() {
            this.onloader = "flex";
            let Id = this.ClassNoteIdval;
            this.$store
                .dispatch("ClassNote/GetClassNoteById", Id)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.ClassNoteItems = resp.data;
                        this.ClassNoteLessonItems = resp.data.classNoteLessons;
                    }
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetClassNoteLessons() {
            let ClassNoteId = this.ClassNoteIdval;
            if (ClassNoteId > 0) {
                this.onloader = "flex";
                const userData = {
                    ClassNoteId
                }
                this.$store
                    .dispatch("ClassNote/GetClassNoteLessons", userData)
                    .then((resp) => {
                        this.ClassNoteLessonItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.ClassNoteItems.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.classNoteLessonTitle.toLowerCase().includes(v) ||
                                item.classNoteLessonDetails.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.ClassNoteLessonItems;
            }
        },

    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetClassNoteById();

        } else {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    },
};
</script>

<style></style>